import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class GamePermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.gameRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.gameImport,
    );
    this.gameAutocomplete = permissionChecker.match(
      Permissions.values.gameAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.gameCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.gameEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.gameDestroy,
    );
  }
}
